import { Switch } from "antd";
import PrimaryButton from "../buttons/PrimaryButton";

export const EasySwitch = ({
  disabled = false,
  checked = false,
  onChange = {},
  size = "small",
}) => {
  return (
    <Switch
      size={size}
      checked={checked === null ? false : checked}
      onChange={onChange}
      disabled={disabled}
    ></Switch>
  );
};

export const ToggleSettingsBrick = ({
  checked,
  onChange,
  title,
  description,
  disabled = false,
}) => {
  return (
    <div className="text-h3 text-shadow_50 font-normal items-start p-2 rounded-lg border-1  flex flex-row gap-4">
      <div className="flex flex-col pt-1">
        <EasySwitch checked={checked} onChange={onChange} disabled={disabled} />
      </div>
      <div className="flex flex-col gap-1">
        <div className="font-medium text-black">{title}</div>
        <div className="text-shadow_50">{description}</div>
      </div>
    </div>
  );
};

export const SaveBar = ({ condition, onClick }) => {
  return (
    <>
      {condition && (
        <div className="fixed top-10 right-10 m-4 z-50">
          <div className="bg-white hover:animate-none  animate-small-bounce shadow-md rounded-lg outline-none outline2 outline-blue-300 p-4 flex flex-col gap-3">
            <div className="text-h3 font-normal w-c300 text-indigo-500">
              Vous devez enregistrer les modifications pour qu'elles soient
              prises en compte.
            </div>
            <PrimaryButton onClick={onClick} className={"w-fit h-fit "}>
              Enregistrer les modifications
            </PrimaryButton>
          </div>
        </div>
      )}
    </>
  );
};
